import { MenuGroup } from './MenuGroup';

export type MenuPresetsType = Record<string, MenuGroup[]>;

export const MenuPresets = {
  Minimal: ['default', 'disable-enter'], // TODO Rinominare in "InlineMinimal"
  Block: ['default', 'title', 'list', 'link', 'return', 'color', 'align'],
  BlockWithoutTitle: ['default', 'list', 'link', 'color', 'return', 'align'],
  Inline: ['default', 'link', 'color', 'disable-enter'],
  InlineWithReturn: ['default', 'link', 'return', 'color', 'disable-enter'],
  InlineWithAlign: [
    'default',
    'link',
    'return',
    'color',
    'align',
    'disable-enter',
  ],
} satisfies MenuPresetsType;
